import { Button, Image, message, Rate, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import {
	active,
	LandingTitle,
	searchStyle,
} from "../../lib/styles/styleLibrary";
// import Venues from "../../assets/svg/home.svg";
// import Band from "../../assets/svg/band.svg";
// import cake from "../../assets/svg/cake.svg";
// import deco from "../../assets/svg/deco.svg";
// import dress from "../../assets/svg/dress.svg";
// import Food from "../../assets/svg/food.svg";
// import planner from "../../assets/svg/planner.svg";
// import video from "../../assets/svg/video.svg";
import { ReactComponent as Home } from "../../assets/svg/NavIcons/compass.svg";
import bm_filled from "../../assets/svg/bookmark_filled.svg";
import bm from "../../assets/svg/bookmark.svg";
import Search from "antd/lib/input/Search";
import searchLogo from "../../assets/svg/search.svg";
import pin from "../../assets/svg/map-pin.svg";
import hall from "../../assets/images/hall.png";
// import hall1 from "../../assets/images/vendor/hall1.png";
// import hall2 from "../../assets/images/vendor/hall2.png";
// import hall3 from "../../assets/images/vendor/hall3.png";
import { useMutation, useQuery } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import {
	fetchAllVendors,
	fetchVendorBookmarked,

	rateVendor,
	setVendorFavorite,
} from "../../redux/actions/vendor";
import { iconList } from "../../settings/paths";
import { EmptyData, Loading, PageLoading } from "../../components";
import {
	BookmarkWrapper,
	CardContainer,
	VendorItem,
	VendorItemWrapper,
	Wrapper,
} from "./component";
import { Link } from "react-router-dom";
import { useVendorCategory } from "../../redux/api/VendorHooks";

const Vendors = (props) => {
	const [search, setSearch] = useState("");
	const [selectedVendor, setSelectedVendor] = useState({});
	const [catId, setCatId] = useState(1);
	const [fields, setFields] = useState({
		title: "",
		description: "",
	});

	// const getIcon = (name) => {
	// 	const icons = {
	// 	  Football: Football,
	// 	  Golf: Golf,
	// 	  'American Football': AmericanFootball,
	// 	  Baseball: Baseball
	// 	};

	// 	return icons[name] || Flag;
	//   };
	// const Icon = getIcon(sport.name);
	// 	<IconContainer color={colors[index]}>
	// 	<Icon />
	//   </IconContainer>

	const { data: vendorCategories, isLoading: loadingCategories } =
		useVendorCategory();

	const {
		data: vendorBookmarked,
		isLoading: loadingVBookmarked,
		refetch: refetchBookmarked,
	} = useQuery("vendorBookmarked", fetchVendorBookmarked, {
		refetchOnWindowFocus: false,
	});

	const {
		data: vendorsList,
		isLoading: loadingAllVendors,
		refetch,
	} = useQuery(["All_Vendors", catId], () => fetchAllVendors(catId), {
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		refetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [catId]);

	const bookmarkedVendors = vendorBookmarked?.vendors;
	const vendors = vendorsList?.vendors;

	const { mutateAsync: handleFavorite } = useMutation(setVendorFavorite);
	const handleSetFav = async (bookmark) => {
		console.log(bookmark);
		if (isEmpty(bookmark.vendorId) || isEmpty(bookmark.action)) {
			message.warning("Please wait...");
			return;
		}
		try {
			const response = await handleFavorite(bookmark);
			console.log(response);
			const { hasError } = response;
			if (hasError) {
				const { title, message } = response.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${response.message}`,
				});
			}
		} catch (err) {
			console.log(err);
			return false;
		} finally {
			refetch();
			refetchBookmarked();
		}
	};

	const { mutateAsync: handleRating } = useMutation(rateVendor);

	const handleVendorRating = async (rating) => {
		console.log(rating);
		if (isEmpty(rating.vendorId) || isEmpty(rating.rating)) {
			message.warning("Please wait...");
			return;
		}
		try {
			const response = await handleRating(rating);
			console.log(response);
			const { hasError } = response;
			if (hasError) {
				const { title, message } = response.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			}
		} catch (err) {
			console.log(err);
			return false;
		} finally {
			refetch();
			refetchBookmarked();
		}
	};

	const { mutateAsync: handleSearch, isLoading: searchloading } =
		useMutation();
	const handleSearchVendor = async (e) => {
		e.preventDefault();
		if (isEmpty() || isEmpty()) {
			message.warning("Please wait");
			return;
		}
		try {
			const response = await handleSearch(fields);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				const { title, message } = response.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `Note created successfully`,
				});
			}
		} catch (err) {
			console.log(err);
			return false;
		}
	};

	return (
		<MainLayout>
			<Wrapper>
				{loadingVBookmarked && <PageLoading />}
				<div tw="flex flex-row flex-nowrap items-center justify-between">
					<LandingTitle tw="text-2xl font-bold leading-8 m-0! whitespace-pre">
						Find Vendors{" "}
					</LandingTitle>

					<Button
						tw="rounded-2xl text-white bg-appPink hover:(bg-appPinkSaturated text-white)"
						style={{ fontSize: "10px" }}>
						INVITE VENDOR
					</Button>
				</div>
				<div
					tw="mt-4 mb-4 flex flex-row flex-nowrap items-center gap-2 overflow-x-scroll"
					className="hide-scrollbar">
					{loadingCategories
						? Array.apply(null, Array(4)).map((i) => {
								return (
									<Skeleton.Button
										key={i}
										active={true}
										size={"large"}
										shape={"round"}
									/>
								);
						  })
						: vendorCategories?.map((cat, i) => {
								return (
									<Button
										key={i}
										onClick={() => {
											setCatId(cat.id);
										}}
										css={cat.id === catId && active}
										tw="rounded-2xl min-w-min text-white! bg-gray-400 inline-flex gap-2 border-none  items-center justify-center py-4 px-5 hover:(bg-appPinkSaturated text-white!) active:(bg-appPinkSaturated! text-white! text-xs font-medium shadow) focus:(bg-appPink text-white border-none)">
										<Image
											preview={false}
											src={
												iconList[i]?.name === cat?.title
													? iconList[i]?.src
													: Home
											}
											alt=""
											width={15}
											height={16}
											tw="rounded-md"
										/>

										<span tw="text-sm font-semibold">
											{cat?.title}
										</span>
									</Button>
								);
						  })}
				</div>
				<BookmarkWrapper style={{ minHeight: "60vh" }}>
					<div tw="mt-4">
						<CardContainer
							tw="w-full h-60 shadow-md min-w-min"
							background={hall}>
							<div tw="flex items-center p-6 h-full">
								<Search
									placeholder="Search by name or location"
									enterButton="Search"
									size="middle"
									css={searchStyle}
									value={search}
									onChange={(e) => {
										setSearch(e.target.value);
									}}
									loading={false}
									prefix={
										<img
											src={searchLogo}
											alt=""
											tw="pr-2"
										/>
									}
									onSearch={() => {
										alert(`You searched for ${search}`);
										setSearch("");
									}}
								/>
							</div>
						</CardContainer>
					</div>

					{!isEmpty(bookmarkedVendors) && (
						<div tw="mt-4">
							<h3 tw="text-sm font-light">My Bookmarks</h3>
							<VendorItemWrapper>
								{bookmarkedVendors?.map((vendor, i) => {
									return (
										<VendorItem key={i}>
											<div tw="rounded-2xl">
												<Link
													to={`vendors/view/${vendor.id}`}>
													<Image
														preview={false}
														src={
															!isEmpty(
																vendor.vendor_cover_image
															)
																? vendor
																		.vendor_cover_image
																		?.media_url
																: ""
														}
														alt=""
														width={120}
														height={135}
														fallback="data:image/png;base64,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"
														tw="bg-appGentleGray rounded-2xl"
														placeholder={
															<Image
																preview={false}
																src={
																	vendor
																		.vendor_cover_image
																		?.media_url_min
																}
																width={120}
																height={130}
																tw="bg-appGentleGray rounded-2xl"
															/>
														}
														style={{
															imageRendering:
																"pixelated",
														}}
													/>
												</Link>
											</div>
											<div tw="w-full flex flex-col relative">
												<div tw="flex flex-row flex-nowrap items-center justify-between">
													<Rate
														value={
															vendor.average_rating
														}
														tw="text-appPink text-xs md:text-base inline-flex flex-nowrap mr-4"
														onChange={(val) => {
															const rating = {
																vendorId:
																	vendor.id,
																rating: val,
															};
															handleVendorRating(
																rating
															);
														}}
													/>

													<span tw="inline-flex items-start gap-2">
														{/* <span tw="font-bold opacity-50 text-tiny sm:text-xs whitespace-nowrap">
																3.2 KM Away
															</span> */}
														<Image
															preview={false}
															src={bm_filled}
															alt=""
															width={15}
															height={20}
															onClick={() => {
																const bookmark =
																	{
																		vendorId:
																			vendor.id,
																		action: "remove",
																	};
																handleSetFav(
																	bookmark
																);
															}}
														/>
													</span>
												</div>
												<Link
													to={`vendors/view/${vendor.id}`}
													style={{
														textDecoration: "none",
														color: "inherit",
													}}>
													<h2 tw="mt-2 text-sm md:text-base lg:text-xl  font-semibold">
														{vendor.stand_name}
													</h2>
													<div
														tw="inline-flex items-center gap-2 absolute bottom-0"
														css={{
															width: "inherit",
														}}>
														<Image
															preview={false}
															src={pin}
															alt=""
															width={15}
															height={20}
														/>
														<span tw="text-xs sm:text-base font-medium opacity-70 truncate  whitespace-pre-wrap">
															{
																vendor.stand_location_address
															}
														</span>
													</div>
												</Link>
											</div>
										</VendorItem>
									);
								})}
							</VendorItemWrapper>
						</div>
					)}

					<div tw="mt-8 mb-16">
						<h3 tw="text-sm font-light">Top rates</h3>
						{loadingAllVendors ? (
							<div tw="flex items-center justify-center p-4">
								<Loading tw="text-appPink" />
							</div>
						) : isEmpty(vendors) ? (
							<div tw="h-full w-full p-4">
								<EmptyData />
							</div>
						) : (
							<VendorItemWrapper>
								{vendors?.map((vendor, i) => {
									return (
										<VendorItem
											key={i}
											onClick={() =>
												setSelectedVendor(vendor)
											}>
											<div tw="rounded-2xl">
												<Link
													to={`vendors/view/${vendor.id}`}>
													<Image
														preview={false}
														src={
															!isEmpty(
																vendor.vendor_cover_image
															)
																? vendor
																		.vendor_cover_image
																		?.media_url
																: ""
														}
														alt=""
														width={120}
														height={135}
														fallback="data:image/png;base64,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"
														tw="bg-appGentleGray rounded-2xl"
														placeholder={
															<Image
																preview={false}
																src={
																	vendor
																		.vendor_cover_image
																		?.media_url_min
																}
																width={120}
																height={130}
																tw="bg-appGentleGray rounded-2xl"
															/>
														}
														style={{
															imageRendering:
																"pixelated",
														}}
													/>
												</Link>
											</div>
											<div tw="w-full min-w-min flex flex-col relative">
												<div tw="flex flex-row flex-nowrap items-center justify-between">
													<Rate
														value={
															vendor.average_rating
														}
														tw="text-appPink text-sm md:text-base inline-flex flex-nowrap mr-4"
														onChange={(val) => {
															const rating = {
																vendorId:
																	vendor.id,
																rating: val,
															};
															handleVendorRating(
																rating
															);
														}}
													/>

													<span tw="inline-flex items-start gap-2">
														{/* <span tw="font-bold opacity-50 text-tiny sm:text-xs whitespace-nowrap">
																3.2 KM Away
															</span> */}
														<Image
															preview={false}
															src={
																vendor.has_bookmarked
																	? bm_filled
																	: bm
															}
															alt=""
															width={15}
															height={20}
															onClick={() => {
																const bookmark =
																	{
																		vendorId:
																			vendor.id,
																		action: vendor.has_bookmarked
																			? "remove"
																			: "add",
																	};
																handleSetFav(
																	bookmark
																);
															}}
														/>
													</span>
												</div>
												<Link
													to={`vendors/view/${vendor.id}`}
													style={{
														textDecoration: "none",
														color: "inherit",
													}}>
													<h2 tw="mt-2 text-base  font-semibold">
														{vendor.stand_name}
													</h2>
													<div
														tw="inline-flex items-center gap-2 absolute bottom-0"
														css={{
															width: "inherit",
														}}>
														<Image
															preview={false}
															src={pin}
															alt=""
															width={15}
															height={20}
														/>
														<span tw="text-xs font-medium opacity-70 truncate whitespace-pre-wrap">
															{
																vendor.stand_location_address
															}
														</span>
													</div>
												</Link>
											</div>
										</VendorItem>
									);
								})}
							</VendorItemWrapper>
						)}
					</div>
				</BookmarkWrapper>
			</Wrapper>
		</MainLayout>
	);
};

export default Vendors;
